import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import {Form, OverlayTrigger, Button} from 'react-bootstrap';
import LinkIconB from '../assets/images/link-iconB.svg';
import TranslationLabel from '../components/TranslationLabel';
import {Base64} from 'js-base64';

function SnapshotModal() {
  const activeFilters = useSelector(state => state.showFilters.activeFilters);
  const question = useSelector(state => state.questions.selectedQuestion);
  const questionNumber = useSelector(state => state.questions.selectedQuestionNumber);
  const questionV = useSelector(state => state.questions.selectedQuestionV);

  const copyText = text => {
    navigator.clipboard.writeText(text);
  };

  const basePath = window.location.href.split('?')[0];

  const setLinkToQuestion = () => {
    setUrl(true);
  };

  const setLinkToTop = () => {
    setUrl(false);
  };

  const setUrl = sw => {
    console.log(sw);
    setCurrentQuestion(sw);
    const strOutput = getUrl(sw);
    setCheckboxValue(strOutput);
  };

  const getUrl = sw => {
    console.log(sw);

    let appendParam = false;
    const outputJson = {};

    if (sw) {
      appendParam = true;
      console.log(question);
      outputJson['question'] = questionV;
    }

    if (activeFilters?.length > 0) {
      appendParam = true;
      outputJson['activeFilters'] = activeFilters;
    }

    console.log(outputJson);

    if (appendParam) {
      const output = Base64.encodeURI(JSON.stringify(outputJson));
      return `${basePath}?s=${output}`;
    } else {
      return basePath;
    }
  };

  const [currentQuestion, setCurrentQuestion] = useState(false);
  const [checkboxValue, setCheckboxValue] = useState(getUrl());

  return (
    <div className="p-3">
      {activeFilters?.length > 0 && (
        <>
          <div className="py-2">
            <TranslationLabel
              id="label_23"
              defaultValue="Link to tool with currently active filters:"
            />
          </div>
          <div className="py-2">
            <ul className="snapshot-list d-inline-block">
              {activeFilters &&
                activeFilters.map((category, index) => (
                  <li key={index}>
                    <strong>{category.title}</strong>
                  </li>
                ))}
            </ul>
            <ul className="snapshot-list d-inline-block pl-3">
              {console.log(activeFilters)}
              {activeFilters &&
                activeFilters.map(category => (
                  <li>
                    {category.filteredCategories.reduce(
                      (prior, current) =>
                        prior != null ? `${prior}, ${current.text}` : current.text,
                      null
                    )}
                  </li>
                ))}
            </ul>
          </div>
        </>
      )}
      <div className="py-2">
        <ul className="snapshot-list">
          <li>
            <strong>
              <Form.Check type={'checkbox'}>
                <Form.Check.Input
                  className="snapshot-checkbox"
                  type={'checkbox'}
                  checked={!currentQuestion}
                  onChange={setLinkToTop}
                />
                <Form.Check.Label>
                  {' '}
                  <TranslationLabel id="label_24" defaultValue="Link to top of survey" />
                </Form.Check.Label>
              </Form.Check>
            </strong>
          </li>
          <li>
            <strong>
              <Form.Check type={'checkbox'}>
                <Form.Check.Input
                  className="snapshot-checkbox"
                  type={'checkbox'}
                  checked={currentQuestion}
                  onChange={setLinkToQuestion}
                />
                <Form.Check.Label>
                  <TranslationLabel id="label_25" defaultValue="Link to top of survey" />:
                </Form.Check.Label>
              </Form.Check>
            </strong>
            {question && <p className="pl-4">{`Q${questionNumber}: ${question}`}</p>}
          </li>
        </ul>
      </div>
      <div className="py-2">
        <Form.Control
          className="snapshot-input"
          disabled
          value={!checkboxValue ? basePath : checkboxValue}
        />
        <OverlayTrigger
          trigger="click"
          placement="right"
          rootClose={true}
          overlay={
            <span style={{zIndex: '12500', paddingLeft: '1rem'}}>
              <TranslationLabel id="label_32" defaultValue="Copied!" />
            </span>
          }
        >
          <Button className="mt-3 copy-link-button" onClick={() => copyText(checkboxValue)}>
            <img src={LinkIconB} alt="placeholder" height={20} width={20} />
            <span className="ml-2">
              <TranslationLabel id="label_26" defaultValue="Copy Link" />
            </span>
          </Button>
        </OverlayTrigger>
      </div>
    </div>
  );
}

export default SnapshotModal;
